import { QRCodeSVG } from "qrcode.react";

export const SlabLabel = ({ s, forwardRef }) => {
  const url = `${window.location.origin}/inventory/slabs/${s.id}`;
  const sqftEach = Math.round(((s.length_in * s.width_in) / 144) * 10) / 10;
  const totalSqft = Math.round(sqftEach * (s.quantity || 1) * 10) / 10;

  return (
    <div
      className="label-4x6 print-label"
      ref={forwardRef}
      data-testid="slab-label-sheet"
    >
      <div className="flex items-start justify-between border-b-2 border-black pb-1">
        <div>
          <div
            style={{
              fontSize: "9pt",
              fontWeight: 700,
              letterSpacing: "0.18em",
            }}
          >
            SLAB STOCK
          </div>
          <div
            className="font-mono-data"
            style={{ fontSize: "18pt", fontWeight: 700 }}
          >
            {s.code}
          </div>
        </div>
        <div style={{ textAlign: "right", fontSize: "9pt", fontWeight: 700 }}>
          <div style={{ border: "2px solid #000", padding: "2px 6px" }}>
            {(s.status || "").toUpperCase()}
          </div>
          <div style={{ marginTop: 4 }}>QTY {s.quantity}</div>
        </div>
      </div>

      <div style={{ marginTop: "0.12in", flex: 1 }}>
        <div style={{ marginBottom: "0.1in" }}>
          <div className="lbl">Slab Color</div>
          <div className="val" style={{ fontSize: "17pt" }}>
            {s.slab_color}
          </div>
        </div>

        {[
          ["Material / Finish", `${s.material} · ${s.finish}`],
          ["Rack", s.location || "—"],
          ["Supplier", s.supplier || "—"],
          ["Serial #", s.serial_number || "—"],
          ["Lot / Bundle", s.lot_number || "—"],
        ].map(([k, v]) => (
          <div key={k} style={{ marginBottom: "0.08in" }}>
            <div className="lbl">{k}</div>
            <div className="val" style={{ fontSize: "12pt" }}>
              {v}
            </div>
          </div>
        ))}

        <div style={{ display: "flex", gap: "0.22in", marginBottom: "0.08in" }}>
          <div>
            <div className="lbl">Size</div>
            <div className="val font-mono-data">
              {s.length_in}" x {s.width_in}"
            </div>
          </div>
          <div>
            <div className="lbl">Thk</div>
            <div className="val font-mono-data">{s.thickness}</div>
          </div>
          <div>
            <div className="lbl">Total</div>
            <div className="val font-mono-data">{totalSqft} ft²</div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid #000", paddingTop: "0.05in" }}>
          <div className="lbl">Notes</div>
          <div
            style={{
              fontSize: "9.5pt",
              lineHeight: 1.3,
              whiteSpace: "pre-wrap",
            }}
          >
            {s.notes || "—"}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          borderTop: "2px solid #000",
          paddingTop: "0.08in",
        }}
      >
        <div style={{ fontSize: "7pt", color: "#333", maxWidth: "2in" }}>
          Scan to open slab record
          <div className="font-mono-data" style={{ fontSize: "7pt" }}>
            {s.id}
          </div>
        </div>
        <QRCodeSVG
          value={url}
          size={88}
          level="M"
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
    </div>
  );
};
